import { useMemo } from 'react';
import { AgileMacroplanogram } from '@components/agile/types/AgileMacroplanogramTypes';
import useGetAssortmentDiff from '@store/hooks/useGetAssortmentDiff';

// This hook provides real ASIN data from all zones for capacity calculations
export const useAllZonesData = (
  isV2Enabled: boolean,
  storeId: string,
  allZones: AgileMacroplanogram[],
  swapTime: number,
  isDraft: boolean,
) => {
  // Get ASIN data from all zones to calculate real occupancy (only when v2 is enabled)
  const { result } = useGetAssortmentDiff(
    {
      storeId: isV2Enabled ? storeId : '',
      timestamp: isV2Enabled ? swapTime : 0,
      macroplanogramIds: isV2Enabled ? allZones?.map((zone) => zone.entryId) || [] : [],
      productEntries: [],
      includeDraft: isV2Enabled ? isDraft : false,
    },
    isV2Enabled ? allZones : undefined,
  );

  return useMemo(() => {
    if (!isV2Enabled || !result.otherItems.length) {
      return [];
    }

    // Transform real ASIN data to the format expected by useZoneCapacityCalculator
    return result.otherItems.map((item) => {
      // Find the zone for this item
      const zone = allZones?.find((z) => z.macroplanogramName === item.zoneName);
      return {
        asin: item.asin,
        uphl2: String(item.uphl2 || item.title || 'Unknown'),
        remainingFacings: item.facingUnits,
        zoneId: zone?.entryId || '',
        subcategoryId: item.subcategoryId ? String(item.subcategoryId) : undefined,
      };
    });
  }, [isV2Enabled, result.otherItems, allZones]);
};

export default useAllZonesData;
